"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Trophy = void 0;
const obejct_diff_1 = require("../utils/obejct-diff");
const network_constants_1 = require("./network.constants");
class Trophy {
    constructor(context) {
        this.context = undefined;
        this.identifier = undefined;
        this.contextId = undefined;
        this.gameRecordId = undefined;
        this.huntingDistrictId = undefined;
        this.huntingDistrictName = undefined;
        this.tagID = undefined;
        this.type = undefined;
        this.typeTitle = undefined;
        this.comment = undefined;
        this.creationDate = undefined;
        this.updateTimestamp = undefined;
        this.context = context;
    }
    setFromAny(element) {
        const { identifier, contextId, gameRecordId, huntingDistrictId, huntingDistrictName, tagID, type, comment, typeTitle, creationDate, updateTimestamp } = element;
        if (!typeTitle && this.type)
            this.typeTitle = this.getTypeTitle();
        this.identifier = identifier ? identifier : this.identifier;
        this.contextId = contextId ? contextId : this.contextId;
        this.gameRecordId = gameRecordId ? gameRecordId : this.gameRecordId;
        this.huntingDistrictId = huntingDistrictId ? huntingDistrictId : this.huntingDistrictId;
        this.tagID = tagID ? tagID : this.tagID;
        this.type = type ? type : this.type;
        this.comment = comment ? comment : this.comment;
        this.creationDate = creationDate ? (0, obejct_diff_1.isDate)(creationDate) ? creationDate : (0, obejct_diff_1.firestoreTimestampToDate)(creationDate) : this.creationDate;
        this.updateTimestamp = updateTimestamp ? (0, obejct_diff_1.isDate)(updateTimestamp) ? updateTimestamp : (0, obejct_diff_1.firestoreTimestampToDate)(updateTimestamp) : this.updateTimestamp;
        this.typeTitle = typeTitle ? typeTitle : this.typeTitle;
        this.huntingDistrictName = huntingDistrictName ? huntingDistrictName : this.huntingDistrictName;
    }
    getTypeTitle() {
        var _a;
        if (this.typeTitle)
            return this.typeTitle;
        if (!this.type)
            return undefined;
        const settingRef = network_constants_1.NetworkConstants.SETTING_TROPY_TYPE;
        const setting = (_a = this.context) === null || _a === void 0 ? void 0 : _a.settingsMap.get(settingRef);
        if (!this.context || !setting)
            return this.type ? this.type : undefined;
        const quality = setting.values.find(el => el.identifier == this.type);
        if (!quality)
            return this.type ? this.type : undefined;
        return quality.title ? quality.title : this.type ? this.type : undefined;
    }
    searchFilter(filter) {
        const str = `${this.type}${this.typeTitle}${this.tagID}`.toLowerCase();
        return str.includes(filter);
    }
    /**
     * Function for skipping objects and data while deepcopying class.
     * used as optional Input for deepCopy(any, replacerFn)
     * @param key
     */
    replacerFn(key) {
        const list = ["context"];
        if (list.includes(key))
            return false;
        else
            return true;
    }
}
exports.Trophy = Trophy;
